import { z } from 'zod';

const EnvironmentConfigSchema = z.object({
  production: z.boolean(),
  agent: z.object({
    url: z.url()
  }),
  api: z.object({
    'baseUrl': z.url(),
    'x-api-key': z.string()
  }),
  uploadsApi: z.object({
    'url': z.url(),
    'x-api-key': z.string()
  }),
  oidc: z.object({
    clientId: z.string(),
    authority: z.string()
  })
});

export type EnvironmentConfig = z.infer<typeof EnvironmentConfigSchema>;

export const validateEnvironmentConfig = (config: unknown) => {
  const { success, error, data } = EnvironmentConfigSchema.safeParse(config);
  if (!success) {
    throw new Error(`Invalid environment config: ${error?.message}`);
  }
  return data;
};
